module.exports = __webpack_public_path__ + "media/img/services/arrow-right-56a50236a4e39827ab1bee0c9a87d1f6.svg";